<template>
<div>
  

  <div class="filter-wrap">
    <div>  
      <Input v-model="sessionKeyword" @on-enter="getSearchSession" placeholder="输入买家名" size="small">
      <Icon type="ios-search" slot="prefix" />
      </Input>
    </div>

    <div>  
      <Dropdown @on-click="selectDropItem" trigger="click">
          <a style="padding: 0px 10px;" href="javascript:void(0)">
              <Icon size="16" color="#666" type="ios-funnel" />
          </a>
          <DropdownMenu slot="list">
              <DropdownItem name="all"><Icon color="#ff6a00" v-show="searchKey == 'all'" type="md-checkmark" />ALL message</DropdownItem>
              <DropdownItem name="noreply"><Icon color="#ff6a00" v-show="searchKey == 'noreply'" type="md-checkmark" />未回复</DropdownItem>
             
          </DropdownMenu>
      </Dropdown>
      <span style="color: rgb(255, 106, 0);font-size: 10px;">{{searchKeyText}}</span>
    </div>
  </div>
    
  <div class="session-container">

    <div class="group-box">
      <Scroll v-show="(sessionKeyword != '' || searchKey != 'all')" :on-reach-bottom="getSearchSessionMore" :height="scrollHeight">
    <ul class="user-list">
      <li class="user" @click="showChat(session)" :class="currentSession && currentSession.conversation_id === session.conversation_id ? 'active' : ''" v-for="(session, index) in searchSession.data" :key="index">
        <a
          href="javascript:"
        >
          <i v-if="session.unread_count > 0">{{ session.unread_count }}</i>
          <img class="head_img" :src="session.to_avatar" alt="头像" />
          <b>{{ session.to_name }}</b>
          <p>{{ session.latest_message_content && session.latest_message_content.text }}</p>
          <p style="width: 95px;left: auto;right: 0px;color: rgb(255, 106, 0);font-size: 14px;" class="text-cut">{{ session.store_name }}</p>
          <span class="last_message_time"><Time :time="timestampFormat(session.last_message_timestamp)" /></span>
        </a>
        <Icon type="md-close" @click="delChat(session)"></Icon>
      </li>
      <Empty :load="searchSession.load"></Empty>
    </ul>
      </Scroll>
    </div>

  <div v-for="(item, index) in sessionData" :key="index" class="group-box">
    <Collapse v-show="(index == shop_id && (sessionKeyword == '' &&  searchKey == 'all') )" v-model="collapseIndex"  >
      <Panel name="1">
        未分配
        <p style="position: relative;" slot="content">
          <Dropdown placement="bottom-start" :stop-propagation="true" trigger="click" style="margin-left: 20px;position: absolute;top: -45px;right: 10px;">
              <a href="javascript:void(0)">
                <span v-if="assignMode == 'view'">视图模式</span>
                  <span v-if="assignMode == 'invitation'">邀请模式</span>
              </a>
              <DropdownMenu style="width: 150px;padding: 0px 5px;" slot="list">
                <DropdownItem @click.native="assignMode = 'view'">视图模式</DropdownItem>
                <DropdownItem @click.native="assignMode = 'invitation'">邀请模式</DropdownItem>                  
              </DropdownMenu>
          </Dropdown>
          <Scroll :height="collapseItemHeight" :on-reach-bottom="invitionMoreSession" :distance-to-edge="-20">
            <ul v-if="item.invition" v-show="(index == shop_id && (sessionKeyword == '' &&  searchKey == 'all') )" class="user-list">
              <li class="user" @contextmenu="showMenu(index)" @click="invitation(session)" :class="currentSession && currentSession.conversation_id === session.conversation_id ? 'active' : ''" v-for="(session, index) in item.invition.data" :key="index">
                <a
                  href="javascript:"
                >
                  <i v-if="session.unread_count > 0">{{ session.unread_count }}</i>
                  <img class="head_img" :src="session.to_avatar">
                  <b>{{ session.to_name }}</b>
                  <p>{{ session.latest_message_content && session.latest_message_content.text }}</p>
                  <span class="last_message_time"><Time :time="timestampFormat(session.last_message_timestamp)" /></span>
                </a>
                <vue-context-menu
                  :contextMenuData="contextMenuData"
                  :transferIndex="transferIndex"
                  @Handler1="transferCsrModelShow(session)"
                ></vue-context-menu>
              </li>
            </ul>
          </Scroll>
        </p>
      </Panel>
      <Panel name="2">
        已分配
        <p style="position: relative;" slot="content">
          <Dropdown placement="bottom-start" :stop-propagation="true" trigger="click" style="margin-left: 20px;position: absolute;top: -45px;right: 10px;">
              <a href="javascript:void(0)">
                  <Icon size="16" color="#666" type="ios-funnel" />
              </a>
              <DropdownMenu style="width: 150px;padding: 0px 5px;" slot="list">
                <Scroll :height="200">
                    <DropdownItem styel="text-align: center;border-bottom: 1px solid #eee;" @click.native="csrSession('all')">
                        <span>全部</span>
                    </DropdownItem>
                    <DropdownItem @click.native="csrSession(null)">
                      <div style="display: flex;justify-content: space-between;">
                        <span>我的</span>
                        <span><Badge status="success" text="在线" /></span>
                      </div>
                    </DropdownItem>
                    <DropdownItem @click.native="csrSession(user)" :key="index" v-for="(user, index) in childUser">
                      <div style="display: flex;justify-content: space-between;">
                        <span>{{ user.username }}</span>
                        <span>                        
                          <Badge v-if="user.status == 3" status="success" text="在线" />
                          <Badge v-if="user.status == 0" status="error" text="离线" />
                          <Badge v-if="user.status == 1" status="warning" text="繁忙" />
                          <Badge v-if="user.status == 2" status="error" text="离开" />
                        </span>
                      </div>
                    </DropdownItem>
                </Scroll>
                  
              </DropdownMenu>
          </Dropdown>
          <Scroll :height="collapseItemHeight2" :on-reach-bottom="recentlyMoreSession" :distance-to-edge="-20">
            <ul v-if="item.recently" v-show="(index == shop_id && (sessionKeyword == '' &&  searchKey == 'all') )" class="user-list">
              <li class="user" @click="showChat(session)" :class="currentSession && currentSession.conversation_id === session.conversation_id ? 'active' : ''" v-for="(session, index) in item.recently.data" :key="index">
                <a
                  href="javascript:"
                >
                  <i v-if="session.unread_count > 0">{{ session.unread_count }}</i>
                  <img class="head_img" :src="session.to_avatar">
                  <b>{{ session.to_name }}</b>
                  <p>{{ session.latest_message_content && session.latest_message_content.text }}</p>
                  <span class="last_message_time"><Time :time="timestampFormat(session.last_message_timestamp)" /></span>
                  <div class="belongcsr" v-if="session.csr">
                    >{{session.csr.username}}
                  </div>
                </a>
                
              </li>
            </ul>
          </Scroll>
        </p>
      </Panel>
    </Collapse>
 
  </div>
  </div>
<Modal
    width="350"
    height="400"
    v-model="transferUserModal"
    :footer-hide="true"
    title="选择客服">
    <Scroll :height="300">    
      <List size="small">
          <ListItem v-for="(user, index) in childUser" :key="index">
            <div :style="{color: user.status == 3 ? '#222' : '#999'}" @click="transferCsr(user)" style="display: flex;justify-content: space-between;width: 100%;padding: 0px 10px;cursor: pointer;">
              <div>              
                {{ user.username }}
              </div>
              <div>              
                 <Badge v-if="user.status == 3" status="success" text="在线" />
                 <Badge v-if="user.status == 0" status="error" text="离线" />
                 <Badge v-if="user.status == 1" status="warning" text="繁忙" />
                 <Badge v-if="user.status == 2" status="error" text="离开" />
              </div>
            </div>
          </ListItem>
      </List>
    </Scroll>
</Modal>
</div>
</template>
<script>

import conf from "../../conf";
import RequestUtils from "../../../../utils/RequestUtils";
import Empty from "../empty.vue";

export default {
  components: {
    Empty,
  },
  data() {
    return {
      // 默认选中的值
      default_img: require("../../../../static/img/default_avatar.png"),
      error_img: 'this.src="'+require("../../../../static/img/default_avatar.png")+'";',
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      sessionKeyword: '',
      searchKey: 'all',
      collapseIndex: [1,2],
      collapseItemHeight: 300,
      collapseItemHeight2: 500,
      scrollHeight: 500,
      sessionCsr: (this.$store.state.user) ? 'all' : '',
      selectSession: {},
      transferUserModal: false, // 转移客服弹窗
      transferIndex: null, // Show the menu that was clicked
      contextMenuData: {
        menuName: "sessionmenu",
        axis: {
          x: null,
          y: null
        },
        menulists: [
          {
            btnName: "分配客服",
            fnHandler: "Handler1"
          }
        ]
      }
    };
  },
  created() {
  },
  props: ["sessionList"],
  computed: {
    currentSession: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.currentSessionData[shop_id];
      }
    },
    currentStore: {
      get: function () {
        return this.$store.state.shopee.currentStore;
      }
    },
    sessionData: {
      get: function() {
        return this.$store.state.shopee.sessionData;
      }
    },
    shop_id: {
      get: function() {
        return this.$store.state.shopee.currentStore.shop_id;
      }
    },
    session: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        if (this.$store.state.shopee.sessionData[shop_id]) {        
          return this.$store.state.shopee.sessionData[shop_id];
        }
        return [];
      },
    },
    searchSession: {
      get: function() {
        return this.$store.state.shopee.searchSession;
      }
    },
    childUser: {
      get: function () {
        return this.$store.state.childUser;
      }
    },
    user: {
      get: function () {
        return this.$store.state.user;
      }
    },
    searchKeyText: {
      get: function () {
        let str = '';
        if (this.searchKey == 'all') {
          str = '全部';
        } else if (this.searchKey == 'noreply') {
          str = '未回复';
        }
        return str;
      }
    },
    assignMode: {
      get: function () {
        return this.$store.state.assignMode;
      },
      set: function (value) {
        this.$store.commit('switdhAssignMode', value);
      }
    },
  },
  watch: {
    currentStore() {
      if (this.searchKey == 'noreply') {
        this.getSearchSession();
      }
    }
  },
  methods: {
    // 右键菜单
    showMenu(index) {
      console.log(index);
      this.transferIndex = index; // tranfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      this.contextMenuData.axis = {
        x,
        y
      };
    },
    transferCsrModelShow (session) {
      this.selectSession = session;
      this.transferUserModal = true;
    },
    transferCsr (user) {
      if (user.status != 3) {
        return false;
      }
      this.transferUserModal = false;
      RequestUtils.webSocketSend('transferCsr', {
        'platform': 'shopee',
        'session_id': this.selectSession.id,
        'admin_id': user.id
      });
    },
    selectDropItem(name) {
      this.searchKey = name;
      if (name == 'noreply') {
        this.getSearchSession();
      }
    },
    showChat(session) {
      this.$emit('showChat', session);
    },
    timestampFormat (timestamp) {
      return (timestamp+"").substr(0, 10)*1;
    },
    invitation(session) {
      if (this.assignMode == 'view') {
        this.showChat(session);
      } else if (this.assignMode == 'invitation') {      
        RequestUtils.webSocketSend('inviteSession', {
          'platform': 'shopee',
          'session_id': session.id
        });
      }
    },
    // 获取对应客服的会话
    csrSession(user) {
      this.sessionCsr = user;

      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("tab", 'recently');
      param.set("page", 1);
      if (this.sessionCsr && this.sessionCsr.id) {      
        param.set("admin_id", this.sessionCsr.id);
      } else if (this.sessionCsr == 'all') {
        param.set("scope", 'all');
      }

      RequestUtils.request(conf.moreSession(), param)
      .then(data => {
        this.$store.commit("shopee/setRecentlyData", data);  
      })
    },
    moreSession(tab) {
      return new Promise(resolve => {
        if (this.session && this.session[tab]) {
          let pageInfo = this.session[tab];
          if (pageInfo.current_page < pageInfo.last_page) {

            let param = new FormData();
            param.set("store_id", this.currentStore.id);
            param.set("tab", tab);
            param.set("page", pageInfo.current_page+1);

            RequestUtils.request(conf.moreSession(), param)
            .then(data => {
              this.$store.commit("shopee/pushSessionList", {
                tab: tab,
                shop_id: this.shop_id,
                data: data
              });
            })
          }
        }

        resolve();
      });
    },
    invitionMoreSession () {
      this.moreSession('invition');
    },
    recentlyMoreSession () {
      this.moreSession('recently');
    },
    handleReachBottom () {
      let self = this;
      return new Promise(resolve => {
        let param = new FormData();
        param.set("store_id", this.session.store_id);
        param.set("connector", 'shopee');
        param.set("direction", 'older');
        param.set("type", 'all');
        param.set("next_timestamp_nano", this.session.page_result.next_cursor.next_message_time_nano);

        RequestUtils.request(conf.getSessionList(), param)
        .then(data => {
          data.conversations = data.conversations.map(function (elem) {
            elem.last_message_timestamp = (elem.last_message_timestamp+"").substr(0, 10)*1;
            return elem;
          });
          data.shop_id = self.session.shop_id;
          self.$store.commit("shopee/pushSessionList", data);
        })

        resolve();
      });
    },
    getSearchSession (page = 1) {
      let param = new FormData();
      param.set("page", page);
      param.set("store_id", this.currentStore.id);
      param.set("keyword", this.sessionKeyword);
      param.set("searchKey", this.searchKey);

      if (typeof page != 'number' || page == 1) {
        this.$store.commit("shopee/setSearchSession", null);
      }
      RequestUtils.request(conf.searchSession(), param)
      .then(data => {
        this.$store.commit("shopee/setSearchSession", data);
      })
    },
    getSearchSessionMore() {
      return new Promise(resolve => {
        if (this.searchSession.current_page < this.searchSession.last_page) {        
          this.getSearchSession(this.searchSession.current_page+1);
        }
        resolve();
      });      
    },
    
  },
  mounted: function() {
    let collapseHeight = document.querySelector('body').offsetHeight - 64 - 36 - 56 - 38*2 - 32*2;
    this.collapseItemHeight = collapseHeight*0.3;
    this.collapseItemHeight2 = collapseHeight*0.7;
    this.scrollHeight = document.querySelector('body').offsetHeight - 64 - 36 - 46 - 44;
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.group-box {
  height: 100%;

  .count {
    color: #aaaaaa;
  }

  li {
    list-style: none;
    position: relative;
    font-size: 1.2rem;
    cursor: pointer;
    font-weight: 200;
    padding: 1rem 0;
    box-sizing: unset;

    h5 {
      padding: 0.5rem 0;
      cursor: pointer;
      font-size: 1.3rem;
      font-weight: 200;

      i {
        vertical-align: baseline;
      }
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      position: absolute;
      top: 0.4rem;
      left: 2rem;
      &:after{
        content: "";
        display: inline-block;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 4.4rem;
        height: 4.4rem;
        background: url("https://fahuo.isellso.net/assets/img/avatar.png") no-repeat;
        background-size: 100% ;
        background-color: #fff;
      }
    }

    .last_message_time {
      position: absolute;
      right: 0px;
      top: 1rem;
      font-size: 10px;
    }

    b {
      position: absolute;
      font-size: 1.3rem;
      left: 7.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      top: 0.6rem;
    }

    p {
      position: absolute;
      left: 7.5rem;
      bottom: 0.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 75%;
      font-size: 1.1rem;
      color: #aaaaaa;
    }
  }
  li.active {
      background-color: $color-gray !important;
  }

  .user {
    height: 5.2rem;
    position: relative;

    a {
      display: block;
      width: 100%;
      height: 100%;
      color: $color-default;
      position: relative;

      i {
        display: inline-block;
        width: 1.8rem;
        height: 1.6rem;
        background-color: #ff0000;
        border-radius: 50%;
        color: $color-write;
        text-align: center;
        font-style: normal;
        position: absolute;
        left: 1rem;
        top: 0;
        z-index: 99;
      }

      p {
        width: 12rem;
      }
    }

    &:hover {
      background-color: $color-gray !important;

      & > i {
        color: $color-default;
        background-color: $color-write;
      }
    }

    .active {
      background-color: $color-gray !important;
    }

    & > i {
      position: absolute;
      right: 1rem;
      bottom: 1.6rem;
      cursor: pointer;
      border-radius: 50%;
      padding: 0.2rem;
      text-align: center;
      color: $color-light-gray;

      &:hover {
        color: $color-default;
        background-color: $color-write;
      }
    }
  }
}
</style>
